export const NotFoundPage = () => {
  return (
    <div className="container pt-xxl text-center">
      <h1 className="dark-blue">404 - page not found</h1>
      <p className="gray">The page you have requested cannot be found</p>
    </div>
  );
};
